import AppConfig from 'dpn-common/config/AppConfig'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'
import { USER_TYPES } from 'dpn-common/utils/AppConstants'

function init() {
    if (!AppConfig.sentryUrl) {
        return
    }
    Sentry.init({
        dsn: AppConfig.sentryUrl,
        integrations: [
            new Integrations.BrowserTracing(),
            new CaptureConsole({
                levels: ['error']
            })
        ],
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
    })
    Sentry.getCurrentHub().getClient().getOptions().enabled = AppConfig.enableSentry
    Sentry.setContext(AppConfig.environment, {
        react: true
    })
}

function dispose() {
}

function setUser(user) {
    if (!AppConfig.sentryUrl) {
        return
    }
    Sentry.setUser(user ? {
        email: user.email,
        userID: user.id + '',
        username: user.username,
        extra: {
            is_teacher: user.role === USER_TYPES.TEACHER
        }
    } : {})
}

function sendMessage(message, severityLevel) {
    if (!AppConfig.sentryUrl) {
        return
    }
    Sentry.captureMessage(message, { level: severityLevel })
}

function sendException(exception) {
    if (!AppConfig.sentryUrl) {
        return
    }
    Sentry.captureException(exception)
}

function sendBreadcrumb(message, category, data, level) {
    if (!AppConfig.sentryUrl) {
        return
    }
    Sentry.addBreadcrumb({ message, category, data, level })
}

function simulateCrash() {
}

export default {
    init,
    dispose,
    setUser,
    sendException,
    sendBreadcrumb,
    simulateCrash,
    sendMessage,
}
